import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

export default {
  list: () => axios.get('/stades')
    .then(response => {
      const array = response.data
      let hashmap = {}
      for (let elem of array) {
        hashmap[elem.code] = elem
      }
      return { array, hashmap }
    })
    .catch(error => errorHandler(error))
}
